import React from 'react'

import DeliverAction from 'components/pages/quarantineAction/DeliverAction'
import BlockAction from 'components/pages/quarantineAction/BlockAction'
import AllowAction from 'components/pages/quarantineAction/AllowAction'
import { UseQn2cFeatureLogicProps } from 'components/pages/quarantineAction/useQn2cFeatureLogic'
import Error from 'components/pages/quarantineAction/Error'

interface QN2CActionHandlerProps {
  logic: UseQn2cFeatureLogicProps
}

export const QN2CActionHandler = ({ logic }: QN2CActionHandlerProps) => {
  const evaluateFlowChart = (): React.ReactElement | null => {
    if (logic?.jwtReturnedValue?.action === 'deliver') {
      return <DeliverAction {...logic.mapDeliverActionProps()} />
    }
    if (logic?.jwtReturnedValue?.action === 'blocklist') {
      return <BlockAction {...logic.mapBlockActionProps()} />
    }
    if (logic?.jwtReturnedValue?.action === 'whitelist') {
      return <AllowAction {...logic.mapAllowActionProps()} />
    }
    return null
  }

  return evaluateFlowChart()
}
